module.exports = __webpack_public_path__ + "static/media/BM_Customers.d6a310b5.svg";